























































import {Component, Prop, Vue} from 'vue-property-decorator'
import * as Helper from '@/helpers'
import {ID} from 'simpli-web-sdk'

@Component
export default class ModalShare extends Vue {
  @Prop({type: String}) name?: string
  @Prop({type: String, default: ''}) text?: string
  @Prop({type: String}) url!: string
  @Prop({type: String}) urlExtra?: string

  get isCielo() {
    return Helper.isCielo()
  }

  copyToClipboard(url?: string) {
    Helper.copyToClipboard(url || '')
    Helper.info('system.info.copiedToClipboard')
  }

  close() {
    this.$modal.close('share')
  }

  openEvent() {
    this.$emit('open')
  }

  closeEvent() {
    this.$emit('close')
  }
}
